import {
    FormControlLabel,
    IconButton,
    TextField,
    Typography
} from "@material-ui/core";
import FormGroup from "@material-ui/core/FormGroup";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputLabel from "@material-ui/core/InputLabel";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import { useTheme } from "@material-ui/styles";
import AddRowButton from "components/common/AddRowButton";
import ContentTitle from "components/common/ContentTitle";
import ButtonController from "components/request-document/components/ButtonController";
import {
    Bagde,
    StyleCheckbox,
    StyledTableCell,
    TableRowHead,
    useStyles
} from "components/request-document/components/Commons";
import { useFormik } from "formik";
import { SMART_T_STEP } from "libs/constant/Step";
import useModalLoading from "libs/hooks/useModalLoading";
import {
    defaultCompanies,
    getDefaultRow,
    getErrorMessage,
    isError,
    mapCompanies
} from "libs/utils/form";
import { get } from "lodash-es";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMasterData, selectMasterData } from "redux/modules/masterSlice";
import { selectPersonalDetail } from "redux/modules/personalSlice";
import {
    selectIsChange,
    selectTypeChange,
    setIsChange,
    setSmartFormStep,
    setTypeChange
} from "redux/modules/uiSlice";
import {
    addSmartForm,
    addSmartFormSlice,
    getSmartForm,
    getSmartFormFieldConfig,
    selectAddSmartForm,
    selectCurrentDocument,
    selectCurrentSmartForm,
    selectCurrentSmartServiceId,
    selectDraftId,
    selectSmartFormFieldConfig,
    selectSubmitSmartForm,
    submitSmartFormSlice
} from "redux/modules/visaForm";
import * as yup from "yup";

export default function AddCompanyInvestmentStep() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const theme = useTheme();
  const { showLoading, hideLoading } = useModalLoading();
  const [isSaveDraft, setSaveDraft] = useState(false);

  const submitSmartFormState = useSelector(selectSubmitSmartForm);
  const personalDetail = useSelector(selectPersonalDetail);
  const smartServiceId = useSelector(selectCurrentSmartServiceId);
  const draftId = useSelector(selectDraftId);
  const masterData = useSelector(selectMasterData);
  const smartFormFieldConfig = useSelector(selectSmartFormFieldConfig);
  const addSmartFormState = useSelector(selectAddSmartForm);
  const smartform = useSelector(selectCurrentSmartForm);
  const currentDocument = useSelector(selectCurrentDocument);
  const isChange = useSelector(selectIsChange);
  const typeChange = useSelector(selectTypeChange);

  const smartNameById = (p, c) => ({ ...p, [c.smartName]: c });

  const defaultType = get(smartFormFieldConfig, "data.defaultType", []);
  const personalId = get(personalDetail, "personalID", "");

  const detailList = [
    "ConditionType",
    "DirectInvestmentTechnology",
    "Investmentthrough",
    "DirectInvestmentStartup",
    "Companies",
  ];
  const detail = get(smartform, "detail", [])
    .filter((field) => detailList.includes(field.smartName))
    .reduce(smartNameById, {});

  console.log("detail", detail);

  useEffect(() => {
    dispatch(
      getMasterData({
        ActivitiesConfig: true,
        AssignmentConfig: true,
        technologyCoreConfig: true,
        technologyEmploymentConfig: true,
        applicantConfig: true,
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (smartServiceId) {
      dispatch(getSmartFormFieldConfig({ smartserviceId: smartServiceId }));
      dispatch(
        getSmartForm({
          smartserviceId: smartServiceId,
          draftId,
          personalId,
        })
      );
    }
  }, [dispatch, draftId, personalId, smartServiceId]);

  useEffect(() => {
    if (!addSmartFormState.isLoading) {
      if (addSmartFormState.isSuccess) {
        hideLoading();
        dispatch(addSmartFormSlice.actions.clearAsyncState());
        dispatch(
          getSmartForm({
            smartserviceId: smartServiceId,
            draftId,
            personalId,
          })
        );
        if (isChange) {
          dispatch(setIsChange(false));
          dispatch(setTypeChange(""));
        }

        if (!isSaveDraft) {
          dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_DOCUMENT));
        }
      } else if (addSmartFormState.isFailure) {
        hideLoading();
        alert(addSmartFormState.error?.message);
        dispatch(addSmartFormSlice.actions.clearAsyncState());
      }
    }
  }, [
    addSmartFormState,
    dispatch,
    draftId,
    hideLoading,
    isChange,
    isSaveDraft,
    personalId,
    smartServiceId,
  ]);

  useEffect(() => {
    if (!submitSmartFormState.isLoading) {
      if (submitSmartFormState.isSuccess) {
        hideLoading();
        dispatch(submitSmartFormSlice.actions.clearAsyncState());
        dispatch(setSmartFormStep(SMART_T_STEP.NONE));
      } else if (submitSmartFormState.isFailure) {
        hideLoading();
        alert(addSmartFormState.error?.message);
        dispatch(submitSmartFormSlice.actions.clearAsyncState());
      }
    }
  }, [
    addSmartFormState.error?.message,
    dispatch,
    hideLoading,
    submitSmartFormState,
  ]);

  const callAPISubmit = async (values) => {
    showLoading();

    const { visaissuance, ...restValues } = values;
    const documentFields = Object.keys(restValues);
    const getFieldListConfig = defaultType.filter((field) =>
      documentFields.includes(field.smartName)
    );
    console.log("getFieldListConfig", getFieldListConfig);

    const getValue = (field) => {
      switch (field.smartName) {
        case "Companies": {
          const companies = get(values, field.smartName, []);
          const value = companies.filter((v) => !!v.CompanyName);
          return value || null;
        }
        default:
          return get(values, `${field.smartName}`, null);
      }
    };
    const getSmartId = (field) =>
      get(detail, `${field.smartName}.smartId`, null);

    const prepareData = {
      draftId: draftId || null,
      smartserviceId: smartServiceId,
      personalId: personalId,
      survey: null,
      visaissuance: null,
      detail: [
        ...getFieldListConfig.map((field) => ({
          smartName: field.smartName,
          smartId: getSmartId(field),
          partfromId: field.partfromId,
          configsmartId: field.configsmartId,
          linkTable: field.linkTable,
          value: getValue(field),
        })),
      ],
    };

    await dispatch(
      addSmartForm({
        data: prepareData,
      })
    );
  };

  const validationSchema = yup.object({});
  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      DirectInvestmentTechnology:
        get(detail, "DirectInvestmentTechnology.value", "False") === "True",
      Investmentthrough:
        get(detail, "Investmentthrough.value", "False") === "True",
      DirectInvestmentStartup:
        get(detail, "DirectInvestmentStartup.value", "False") === "True",
      Companies: getDefaultRow(detail, "Companies.value", defaultCompanies).map(
        mapCompanies
      ),
    },
    onSubmit: async (values) => {
      setSaveDraft(false);
      callAPISubmit(values);
    },
  });

  useEffect(() => {
    if (currentDocument.isSuccess && isChange && typeChange) {
      setSaveDraft(true);
      callAPISubmit({ ConditionType: typeChange });
    }
  }, [currentDocument.isSuccess, isChange, typeChange]);

  const onSaveDraft = () => {
    setSaveDraft(true);
    callAPISubmit(formik.values);
  };

  const Companies = formik.values.Companies || [];

  return (
    <div>
      <ContentTitle
        title="Add Company Investment"
        subTitle="Smart Visa Qualifications Update Form"
      />

      <form onSubmit={formik.handleSubmit}>
        <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan={5}>
                  <Typography variant="h6" className={classes.tableTitle}>
                    Investment in Thailand
                  </Typography>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <StyledTableCell colSpan={5}>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        1. Please select all types of your investment.
                      </InputLabel>

                      <div
                        className={classes.wrapField}
                        style={{ marginTop: 8 }}
                      >
                        <FormGroup row>
                          <FormControlLabel
                            control={
                              <StyleCheckbox
                                name="DirectInvestmentTechnology"
                                value={formik.values.DirectInvestmentTechnology}
                                checked={Boolean(
                                  formik.values.DirectInvestmentTechnology
                                )}
                                onClick={() => {
                                  formik.setFieldValue(
                                    "DirectInvestmentTechnology",
                                    !formik.values.DirectInvestmentTechnology
                                  );
                                }}
                              />
                            }
                            label="Direct investment in technology-based business in Thailand"
                          />
                          <FormControlLabel
                            control={
                              <StyleCheckbox
                                name="Investmentthrough"
                                value={formik.values.Investmentthrough}
                                checked={Boolean(
                                  formik.values.Investmentthrough
                                )}
                                onClick={() => {
                                  formik.setFieldValue(
                                    "Investmentthrough",
                                    !formik.values.Investmentthrough
                                  );
                                }}
                              />
                            }
                            label="Investment through a venture capital company which has invested technology-based business in Thailand"
                          />
                          <FormControlLabel
                            control={
                              <StyleCheckbox
                                name="DirectInvestmentStartup"
                                value={formik.values.DirectInvestmentStartup}
                                checked={Boolean(
                                  formik.values.DirectInvestmentStartup
                                )}
                                onClick={() => {
                                  formik.setFieldValue(
                                    "DirectInvestmentStartup",
                                    !formik.values.DirectInvestmentStartup
                                  );
                                }}
                              />
                            }
                            label="Direct investment in a startup or an incubation or accelerator business in Thailand"
                          />
                        </FormGroup>
                      </div>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRowHead>
                <StyledTableCell colSpan={5}>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <InputLabel>
                      List of companies in which the applicant has invested in
                    </InputLabel>
                  </div>
                </StyledTableCell>
              </TableRowHead>
              <TableRowHead>
                <StyledTableCell align="center">Company Name</StyledTableCell>
                <StyledTableCell align="center">
                  Value of shares (Baht)
                </StyledTableCell>
                <StyledTableCell align="center" colSpan={3}>
                  Amount of convertible debt (Baht)
                </StyledTableCell>
              </TableRowHead>

              {Companies.map((companies, index) => {
                if (!companies.Status) return null;

                return (
                  <TableRow key={index}>
                    <StyledTableCell>
                      <div className={classes.cellContent}>
                        <div className={classes.wrapField}>
                          <TextField
                            variant="outlined"
                            className={classes.textField}
                            name={`Companies.${index}.CompanyName`}
                            value={formik.values.Companies[index]?.CompanyName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={isError(
                              `Companies.${index}.CompanyName`,
                              formik
                            )}
                            helperText={getErrorMessage(
                              `Companies.${index}.CompanyName`,
                              formik
                            )}
                          />
                        </div>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell>
                      <div className={classes.cellContent}>
                        <div className={classes.wrapField}>
                          <TextField
                            variant="outlined"
                            type="number"
                            className={classes.textField}
                            name={`Companies.${index}.ValueofShares`}
                            value={
                              formik.values.Companies[index]?.ValueofShares
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={isError(
                              `Companies.${index}.ValueofShares`,
                              formik
                            )}
                            helperText={getErrorMessage(
                              `Companies.${index}.ValueofShares`,
                              formik
                            )}
                          />
                        </div>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell colSpan={2}>
                      <div className={classes.cellContent}>
                        <div className={classes.wrapField}>
                          <TextField
                            variant="outlined"
                            type="number"
                            className={classes.textField}
                            name={`Companies.${index}.AmountOfConvertibledebt`}
                            value={
                              formik.values.Companies[index]
                                ?.AmountOfConvertibledebt
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={isError(
                              `Companies.${index}.AmountOfConvertibledebt`,
                              formik
                            )}
                            helperText={getErrorMessage(
                              `Companies.${index}.AmountOfConvertibledebt`,
                              formik
                            )}
                          />
                        </div>
                      </div>
                    </StyledTableCell>

                    <StyledTableCell>
                      {index === 0 ? (
                        <div style={{ width: 40 }} />
                      ) : (
                        <>
                          <IconButton
                            style={{
                              width: 40,
                              color: theme.palette.error.main,
                            }}
                            size="small"
                            onClick={async () => {
                              if (
                                get(
                                  formik.values,
                                  `Companies.${index}.companiesId`,
                                  ""
                                )
                              ) {
                                formik.setFieldValue(
                                  `Companies.${index}.Status`,
                                  false
                                );
                              } else {
                                formik.setFieldValue(
                                  "Companies",
                                  Companies.filter((__, i) => i !== index)
                                );
                              }
                            }}
                          >
                            <DeleteForeverIcon />
                          </IconButton>
                          <FormHelperText error={false}> </FormHelperText>
                        </>
                      )}
                    </StyledTableCell>
                  </TableRow>
                );
              })}

              <TableRow>
                <StyledTableCell colSpan={5}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <AddRowButton
                      onClick={() => {
                        formik.setFieldValue("Companies", [
                          ...Companies,
                          mapCompanies(defaultCompanies),
                        ]);
                      }}
                    />
                  </div>
                </StyledTableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            padding: "21px 35px",
          }}
        >
          <InputLabel>
            Note: Please provide details of each company in Form A and
            evidence(s) of shares ownership and value
          </InputLabel>
        </div>
        <ButtonController
          isExtend
          onClickSaveDraft={() => {
            onSaveDraft();
          }}
        />
      </form>
    </div>
  );
}
